module.exports = __webpack_public_path__ + "img/d921e47.png";